import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
// import { request } from "../config/request";
import request from "../../config/request.ts";

interface AutocompleteFieldProps {
  key: string;
  name: string;
  label: string;
  formik: any;
  apiUrl: string;
  apiMethod?: "get" | "post";
  apiPayload?: any;
  optionLabelKey?: string;
  optionValueKey?: string;
  onchangeValue?: (value: any) => void;
}

export default function AutocompleteField({
  key,
  name,
  label,
  formik,
  apiUrl,
  apiMethod = "post",
  apiPayload = {},
  optionLabelKey = "name",
  optionValueKey = "id",
  onchangeValue,
}: AutocompleteFieldProps) {
  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const params = {
          search: inputValue,
          limit: 25,
          offset: 0,
          orderColumn: "sortOrder",
          orderDirection: "ASC",
          ...apiPayload,
        };
        const response = apiMethod === "get"
          ? await request.get(apiUrl, params)
          : await request.post(apiUrl, params);
        setOptions(response.data.data || []);
      } catch (error) {
        console.error("Error fetching options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [inputValue, apiMethod]);

  const selectedOption = options.find(
    (opt) => opt[optionValueKey] === formik.values[name],
  );

  return (
    <Autocomplete
      value={selectedOption || null}
      key={key}
      onChange={(event, newValue) => {
        formik.setFieldValue(name, newValue ? newValue[optionValueKey] : "");
        onchangeValue?.(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      size="small"
      options={options}
      getOptionLabel={(option) => option[optionLabelKey] || ""}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
